import { CivicAddressDto } from 'fourwaves-shared';

export function isCivicAddressValid(address: CivicAddressDto): boolean {
  if (address.addressLine1 && address.city && address.postalCode) {
    if (address.countryRegion === 'CA' || address.countryRegion === 'US') {
      return !!address.stateProvince;
    } else {
      return !!address.countryRegion;
    }
  } else {
    return false;
  }
}
